const initialState = {
  isLoading: false,
  Token: null,
  UsernameL: "",
  PasswordL: "",
};
export default initialState;
